module.exports = __webpack_public_path__ + "img/picture_yctgg.26d984e8.png";